// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.test-detail-section {
  border: 1px solid #e3e8ef;
  border-radius: 4px;
  padding: 0.65rem;
  background: #ffffff;
}

.test-detail-title {
  margin: 0 0 0.55rem;
  font-size: 0.85rem;
  font-weight: 700;
  color: #3f4954;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.test-detail-fields {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0.65rem 1rem;
}

.test-detail-field--full {
  grid-column: 1/-1;
}

.test-detail-field {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.test-detail-inline-values {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.65rem;
}

.test-detail-label {
  margin: 0;
  font-size: 0.85rem;
  color: #555;
  font-weight: 600;
}

.test-detail-subtitle {
  margin: 0 0 0.45rem;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-align: center;
  text-transform: uppercase;
  color: #475569;
}

@media (max-width: 680px) {
  .test-detail-fields {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 430px) {
  .test-detail-fields {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/job-details/job-request-overview/test-details/job-request-test-wbm-salinity-detail.component.scss"],"names":[],"mappings":"AAAA;EAAuB,yBAAA;EAA2B,kBAAA;EAAoB,gBAAA;EAAkB,mBAAA;AAKxF;;AAJA;EAAqB,mBAAA;EAAqB,kBAAA;EAAoB,gBAAA;EAAkB,cAAA;EAAgB,kBAAA;EAAoB,yBAAA;EAA2B,sBAAA;AAc/I;;AAbA;EAAsB,aAAA;EAAe,gDAAA;EAAkD,iBAAA;AAmBvF;;AAlBA;EAA2B,iBAAA;AAsB3B;;AArBA;EAAqB,aAAA;EAAe,sBAAA;EAAwB,WAAA;AA2B5D;;AA1BA;EAA6B,aAAA;EAAe,gDAAA;EAAkD,YAAA;AAgC9F;;AA/BA;EAAqB,SAAA;EAAW,kBAAA;EAAoB,WAAA;EAAa,gBAAA;AAsCjE;;AArCA;EAAwB,mBAAA;EAAqB,kBAAA;EAAoB,gBAAA;EAAkB,sBAAA;EAAwB,kBAAA;EAAoB,yBAAA;EAA2B,cAAA;AA+C1J;;AA7CA;EACC;IAAsB,gDAAA;EAiDrB;AACF;AA/CA;EACC;IAAsB,0BAAA;EAkDrB;AACF","sourcesContent":[".test-detail-section { border: 1px solid #e3e8ef; border-radius: 4px; padding: 0.65rem; background: #ffffff; }\n.test-detail-title { margin: 0 0 0.55rem; font-size: 0.85rem; font-weight: 700; color: #3f4954; text-align: center; text-transform: uppercase; letter-spacing: 0.02em; }\n.test-detail-fields { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 0.65rem 1rem; }\n.test-detail-field--full { grid-column: 1 / -1; }\n.test-detail-field { display: flex; flex-direction: column; gap: 0.3rem; }\n.test-detail-inline-values { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 0.65rem; }\n.test-detail-label { margin: 0; font-size: 0.85rem; color: #555; font-weight: 600; }\n.test-detail-subtitle { margin: 0 0 0.45rem; font-size: 0.78rem; font-weight: 700; letter-spacing: 0.02em; text-align: center; text-transform: uppercase; color: #475569; }\n\n@media (max-width: 680px) {\n\t.test-detail-fields { grid-template-columns: repeat(2, minmax(0, 1fr)); }\n}\n\n@media (max-width: 430px) {\n\t.test-detail-fields { grid-template-columns: 1fr; }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
